/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable array-element-newline */
/* eslint array-element-newline: ["error", "never"] */
import React from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';

const handleOnClick = (event) => {
    const { target } = event;

    if (target.selectionEnd <= 2 && target.selectionend <= 2) {
        target.setSelectionRange(2, 2);
    } else {
        const valueSelected = target.value.substring(0, target.selectionEnd || target.selectionend);
        const match = valueSelected.match(/\d/gi);
        if (match) {
            const lastDigitIndexInSelection = valueSelected.lastIndexOf(match[match.length - 1]) + 1;
            target.setSelectionRange(
                lastDigitIndexInSelection,
                lastDigitIndexInSelection,
            );
        }
    }
};

const CreditCardMask = (props) => {
    const {
        inputRef, className, value, ...other
    } = props;
    const cardType = className.replace(
        /[\s\S]+-cardtype-([^-]+)-[\s\S]*/,
        '$1',
    );
    const DefaultFormat = [
        /[\d|\u2022]/,
        /[\d|\u2022]/,
        /[\d|\u2022]/,
        /[\d|\u2022]/,
        ' ',
        ' ',
        /[\d|\u2022]/,
        /[\d|\u2022]/,
        /[\d|\u2022]/,
        /[\d|\u2022]/,
        ' ',
        ' ',
        /[\d|\u2022]/,
        /[\d|\u2022]/,
        /[\d|\u2022]/,
        /[\d|\u2022]/,
        ' ',
        ' ',
        /[\d|\u2022]/,
        /[\d|\u2022]/,
        /[\d|\u2022]/,
        /[\d|\u2022]/,
    ];
    const AMEXFormat = [
        /[\d|\u2022]/,
        /[\d|\u2022]/,
        /[\d|\u2022]/,
        /[\d|\u2022]/,
        ' ',
        ' ',
        /[\d|\u2022]/,
        /[\d|\u2022]/,
        /[\d|\u2022]/,
        /[\d|\u2022]/,
        /[\d|\u2022]/,
        /[\d|\u2022]/,
        ' ',
        ' ',
        /[\d|\u2022]/,
        /[\d|\u2022]/,
        /[\d|\u2022]/,
        /[\d|\u2022]/,
        /[\d|\u2022]/,
    ];
    let CCFormat = DefaultFormat;
    if (/^3[47]/.test(value) || cardType === 'AX') {
        CCFormat = AMEXFormat;
    }
    return (
        <MaskedInput
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...other}
            className={className}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={CCFormat}
            value={value}
            placeholderChar={'\u2000'}
            onChange={(event) => handleOnClick(event)}
            data-testid="my-account-credit-card"
        />
    );
};

CreditCardMask.defaultProps = {
    value: '',
    className: '',
};

CreditCardMask.propTypes = {
    inputRef: PropTypes.func.isRequired,
    className: PropTypes.string,
    value: PropTypes.string,
};

export default CreditCardMask;
